import React from 'react';
import { connect } from 'react-redux';

import FormMainInfo from './index';

class Screen extends React.Component {
  render() {
    const { workspace } = this.props;

    return <FormMainInfo initialValues={workspace} />;
  }
}

const mapStateToProps = ({ workspace }) => ({
  workspace: workspace.data,
});

export default connect(mapStateToProps)(Screen);



// WEBPACK FOOTER //
// ./src/admin/settings/Screen.js